import React from 'react';
import PropTypes from 'prop-types';
import closeFlyoutImage from '../../images/close_rightpanel.svg';

const Flyout = ({
  children = [],
  isOpen = false,
  isStatic = false,
  classes = '',
  handleClose = () => {},
}) => (
  <div className={`flyout ${classes}`} data-static={isStatic} data-open={isStatic || isOpen}>
    {!isStatic &&
      <div role='button' tabIndex={-1} className='flyout-close' onClick={handleClose}>
        <img alt='close flyout' src={closeFlyoutImage} width='20' height='20' />
      </div>
    }
    <div className='flyout-content'>
      {(isStatic || isOpen) && children}
    </div>
  </div>
);

Flyout.propTypes = {
  handleClose: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.instanceOf(Array)]),
  isOpen: PropTypes.bool,
  isStatic: PropTypes.bool,
  classes: PropTypes.string,
};

Flyout.defaultProps = {
  children: [],
  isStatic: false,
  isOpen: false,
  classes: '',
};

export default Flyout;



// WEBPACK FOOTER //
// ./src/views/Components/Flyout.js